const addMlnSuffix = (value, valueTransform = (v) => v) => {
  if (typeof value !== "number") return;
  if (value < 1e6) return valueTransform(value);

  const valueMln = Number((value / 1e6).toFixed(2));
  return `${valueTransform(valueMln)} mln`;
};

export default addMlnSuffix;
